import { Button, EButtonColorVariant } from '@outdoorsyco/bonfire';
import React from 'react';

import { isSSR } from '@/utility/isSSR';
import { isUrlAbsolute } from '@/utility/isUrlAbsolute';

import ResponsiveImage from '../utility/ResponsiveImage/ResponsiveImage';
import HeroImages from './HeroImages';

const Hero = ({ title, subtitle, buttonUrl: rawButtonUrl, buttonLabel, heroImg } = {}) => {
  let buttonUrl = rawButtonUrl;
  if (buttonUrl && !isSSR()) {
    if (!isUrlAbsolute(buttonUrl)) {
      buttonUrl = new URL(buttonUrl, document.baseURI).href;
    }
  }
  return (
    <div className={`grid gap-2  grid-cols-1 md:grid-cols-3`}>
      <div className={`py-6 px-4 lg:p-20 w-100 lg:pl-0`}>
        <h1 className="text-3xl font-medium leading-tight md:text-4xl">{title}</h1>
        <h2 className="mt-4 text-xl text-gray-500">{subtitle}</h2>
        {buttonUrl && (
          <Button
            className="mt-4"
            fullWidth
            href={buttonUrl}
            variant={EButtonColorVariant.Primary}
            label={buttonLabel}
          />
        )}
      </div>
      <div className={`col-span-2 w-100 h-100 min-w-auto mt-0 md:mt-4 self-center overflow-hidden`}>
        {heroImg && (
          // width/height reserve space to prevent layout shift (CLS). This hero is the
          // fixed 763×400 `how-it-works-lp-hero` rendition (HeroTwo only renders the
          // how-it-works page). Tailwind preflight (img { max-width:100%; height:auto })
          // keeps it responsive and undistorted.
          <ResponsiveImage
            className="md:rounded"
            src={heroImg}
            alt={title || ''}
            width={763}
            height={400}
            priority={true}
            withFetchPriority="high"
          />
        )}
        {!heroImg && <HeroImages />}
      </div>
    </div>
  );
};

export default Hero;
